module.exports = __webpack_public_path__ + "static/img/concat.5df0b90d.png";